export default "__VITE_ASSET__3d098019__"